import InitialLoad from './InitialLoad';
import Confirmation from './Confirmation';
import Resetting from './Resetting';
import ResetFail from './ResetFail';
import ResetCancel from './ResetCancel';
import ResetSuccess from './ResetSuccess';
export default {
  InitialLoad,
  Confirmation,
  Resetting,
  ResetFail,
  ResetSuccess,
  ResetCancel
};